import { render, staticRenderFns } from "./Payc01View.vue?vue&type=template&id=d6f4c2f4&scoped=true&"
import script from "./Payc01View.vue?vue&type=script&lang=ts&"
export * from "./Payc01View.vue?vue&type=script&lang=ts&"
import style0 from "./Payc01View.vue?vue&type=style&index=0&id=d6f4c2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f4c2f4",
  null
  
)

export default component.exports